import React from "react";
import { observer } from "mobx-react";
import History from "./history";
import Prompt from "./prompt";

import "./style/conversation.scoped.scss";

const Conversation = observer(
    ({
        activeChat,
        messages,
        loading,
        busy,
        onPrompt,
        onShowRef,
        onThumbsUp,
        onThumbsDown,
        onCancel,
        onEditMessage,
    }) => {
        return (
            <div className="conversation">
                <History
                    activeChat={activeChat}
                    messages={messages}
                    loading={loading}
                    onShowRef={onShowRef}
                    onThumbsUp={onThumbsUp}
                    onThumbsDown={onThumbsDown}
                    onCancel={onCancel}
                    onEditMessage={onEditMessage}
                />
                <Prompt onPrompt={onPrompt} busy={busy} />
            </div>
        );
    },
);

export default Conversation;
